import { Money } from "./schemas";

export class ZahlungModel {
    // Vertragnepraunik
    Id: string;
    Betrag: Money;
    Betragoffen: Money;
    Baufortschritt: string;
    ZielDateString: string;
}


// WEBPACK FOOTER //
// ./src/app/schemas/ZahlungModel.ts